<template>
  <div class="kakunin">
    <div class="kakunin-step">
      <FormStep v-bind:step="2"></FormStep>
    </div>

    <div class="kakunin-form">
      <FormWaku v-for="(i, index) in kakunin_form" v-bind:key="index">
        <template v-slot:title>{{ form_name[index] }}</template>
        <template>
          <P class="warp">{{ i }}</P>
        </template>
      </FormWaku>
    </div>
    <div v-on:click="soushin">
      <FormBtn>
        <template>この内容で送信する</template>
      </FormBtn>
    </div>
  </div>
</template>

<script>
import FormWaku from "@/components/form_waku.vue";
import FormStep from "@/components/form_step.vue";
import FormBtn from "@/components/form_btn.vue";

var form_name = {
  job: "職種選択",
  kinmuchi: "希望勤務地",
  namae: "お名前",
  furigana: "ふりがな",
  seibetsu: "性別",
  graduate: "卒業(予定)年月",
  university: "所属している学校名",
  juusyo: "住所",
  tel: "電話番号",
  mail: "メールアドレス",
  question: "ご質問･ご要望など"
};
export default {
  metaInfo: {
    title: "入力内容確認"
  },
  name: "kakunin-form",
  components: {
    FormWaku,
    FormStep,
    FormBtn
  },
  props: ["form_data", "click"],
  methods: {
    soushin() {
      //入力内容をfetchで送る
      var formData = new FormData();
      formData.append("form_data", JSON.stringify(this.form_data));
      fetch("https://famitei.co.jp/newgrad/api/send.php", {
        method: "POST",
        body: formData,
        cors: true
      });

      //ローカルストレージを削除
      this.$emit("removeData");

      //送信完了画面に飛ぶ
      this.$router.push("/soushin");
    }
  },
  mounted() {
    //リロードしても前画面に戻らないようにする
    if (window.performance) {
      if (performance.navigation.type === 1) {
        this.click = true;
      }
    }
    if (!this.click) {
      this.$router.replace("/");
    }
    window.scroll(top);
  },
  computed: {
    kakunin_form() {
      var data = {};
      data.job = this.form_data.job;
      data.kinmuchi = this.form_data.kinmuchi.join(" / ");
      data.namae = this.form_data.name.kanji;
      data.furigana = this.form_data.name.furigana;
      data.seibetsu = this.form_data.seibetsu;
      data.graduate =
        this.form_data.graduate.year +
        "年" +
        this.form_data.graduate.month +
        "月";
      data.university = this.form_data.university;
      if(this.form_data.juusyo.yuubin_num){
        data.juusyo = 
        "〒" +
        this.form_data.juusyo.yuubin_num +
        "\n" +
        this.form_data.juusyo.address;
      }else{
        data.juusyo = this.form_data.juusyo.address;
      }
      data.tel = this.form_data.tel;
      data.mail = this.form_data.mail;
      data.question = this.form_data.question;
      return data;
    },
    form_name() {
      return form_name;
    }
  }
};
</script>
<style lang="scss">
.kakunin {
  //pc style
  @media screen and (min-width: 769px) {
    &-form {
      border: 1px solid #c8c8c8;
      max-width: 800px;
      margin: 10px auto;
    }
  }
  &-btn {
    text-align: center;
  }
}
</style>
